import { AgCharts } from 'ag-charts-react';
import useConnectedCashPositionOverview from '../../../../../customhooks/useConnectedCashPositionOverview';
import { AgChartOptions } from 'ag-charts-community';

const CreditDebitRatioCard = () => {
    const { entries: data = [] } = useConnectedCashPositionOverview();

    const options: AgChartOptions = {
        data,
        series: [
            { type: 'bar' as const, xKey: 'month', yKey: 'inflow', yName: 'Credit', stacked: true, fill: '#0088B2' },
            { type: 'bar' as const, xKey: 'month', yKey: 'outflow', yName: 'Debit', stacked: true, fill: '#66B7D0' },
        ],
         axes: [
            { type: 'number', position: 'left', label: { formatter: ({ value }) => `${value/1_000_000}M`} },
            { type: 'category', position: 'bottom' },
        ]
    }

    return (
        <div className='w-full bg-white border border-appcolorfaintnine rounded-[24px] py-5 px-6 flex flex-col justify-between'>
            <div className='text-gray700 text-[18px] mb-4'>
                Credit/Debit Ratio
            </div>
            <div className='w-full h-full'>
                <AgCharts options={options} />
            </div>
        </div>
    );
};

export default CreditDebitRatioCard;
